import { ReauthErrorKind } from '@griply/types';

export const getReauthErrorMessageKey = (kind: ReauthErrorKind): string => {
  if (kind === ReauthErrorKind.WrongPassword) {
    return 'dialogs.delete-account.reauth.error.wrong-password';
  }

  if (kind === ReauthErrorKind.UserMismatch) {
    return 'dialogs.delete-account.reauth.error.user-mismatch';
  }

  return 'dialogs.delete-account.reauth.error.generic';
};
